import React, { Component, PropTypes } from 'react';
import moment from 'moment';
import { connect } from 'react-redux';

import './style.scss';
import DetailLabel from 'components/DetailLabel';
import Goals from 'containers/Goals';
import { GoalShape } from 'entities';

class ChatGoals extends Component {

  render() {
    return (
      <div className="ChatResource ChatGoals">
        <div className="preview">
          <div className="content">
            <Goals goals={this.props.goals} source={process.env.KOOTH_USER_CHAT}/>
          </div>
        </div>

        <DetailLabel>{moment(this.props.lastUpdated).fromNow()}</DetailLabel>
      </div>
    );
  }
}

ChatGoals.propTypes = {
  lastRefresh: PropTypes.object,
  lastUpdated: PropTypes.object,
  goals: PropTypes.arrayOf(GoalShape)
};

const mapStateToProps = (state, ownProps) => {
  const goalsUpdates = ownProps.goals.map(goal => goal.updatedAt);
  goalsUpdates.sort((date1, date2) => date2 - date1);

  return {
    lastUpdated: goalsUpdates[0]
  };
};

const mapDispatchToProps = () => {
  return {};
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ChatGoals);



/** WEBPACK FOOTER **
 ** ./src/members/Main/ChatWindow/ChatItems/ChatGoals/index.js
 **/